<section class="konto-sektion" [attr.aria-labelledby]="titelId">
  <div class="konto-sektion__kopf">
    <div class="konto-sektion__text">
      <h2 class="konto-sektion__titel" [id]="titelId">{{ titel() }}</h2>
      @if (untertitel()) {
        <p class="konto-sektion__untertitel">{{ untertitel() }}</p>
      }
    </div>
    <ng-content select="[rechts]" />
  </div>
  <ng-content />
</section>
